import React, { ReactNode } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { CheckCircleOutlined } from '@mui/icons-material';
import { InfoTooltip } from 'components';

type TargetingOverviewBlockProps = {
  title: ReactNode;
  description: ReactNode;
  tooltipText: ReactNode;
};

export const TargetingOverviewBlock = ({ title, description, tooltipText }: TargetingOverviewBlockProps) => {
  return (
    <Stack spacing={4}>
      <Box display="inline-block">
        <CheckCircleOutlined sx={{ mr: 2, transform: 'translateY(4px)' }} />
        <Typography display="inline" sx={{ mr: 2 }} variant="subtitle1" fontWeight={700}>
          {title}
        </Typography>
        <Box sx={{ display: 'inline-block', transform: 'translateY(-4px)' }}>
          <InfoTooltip placement="top" text={tooltipText} />
        </Box>
      </Box>
      <Divider />
      {description}
    </Stack>
  );
};
